export const QUIZ_FEATURE_KEY = 'quiz';
